import { SponsorCards } from "../components/index";
import { NavBarTest } from "../../../components/NavBarTest";
import { Footer } from '../../../components/index';

export const Sponsors = () => {
  document.title = "Venture Summit Digital Connect | Sponsors";
  return (
    <div style={{backgroundColor:'#212529'}}>
      <NavBarTest />
      <SponsorCards />
      <Footer />
    </div>
  );
};
